import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";

export class ApplyForLeavesDto{
    applyForLeavesId: number;
    employeeId: number;
    // employeeCode: string;
    typeOfLeave: number;
    fromDate:Date;
    toDate: Date;
    leaveToDay:string;
    noOfDays:number;
    leaveReason:string;
    leaveAddress:string;
    isActive: boolean;
    updatedAt: Date | any;
    updatedUser: string;
    createdAt: Date | any;
    createdUser: string;
    versionFlag: number;
    status?: LeaveApprovalStatusEnum;
    employeeName? :string ;

    constructor(
    applyForLeavesId: number,
    employeeId: number,
    // employeeCode: string,
    typeOfLeave: number,
    fromDate:Date,
    toDate: Date,
    leaveToDay:string,
    noOfDays:number,
    leaveReason:string,
    leaveAddress:string,
    isActive: boolean,
    updatedAt: Date | any,
    updatedUser: string,
    createdAt: Date | any,
    createdUser: string,
    versionFlag: number,
    status?:LeaveApprovalStatusEnum,
    employeeName? :string 
    ){
        this.applyForLeavesId = applyForLeavesId;
        this.employeeId = employeeId;
        // this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.typeOfLeave = typeOfLeave;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.leaveToDay = leaveToDay;
        this.noOfDays = noOfDays;
        this.leaveReason = leaveReason;
        this.leaveAddress = leaveAddress;
        this.isActive = isActive;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.versionFlag = versionFlag;
        this.status = status;
        this.employeeName = employeeName;

    }
}

